import { render } from "./DefaultModal.vue?vue&type=template&id=16594747"
import script from "./DefaultModal.vue?vue&type=script&lang=ts"
export * from "./DefaultModal.vue?vue&type=script&lang=ts"
script.render = render

export default script